import React, { useState, useRef } from "react";
import backgroundImage from "~/images/modal-background-image.png";
import { Close } from "@mui/icons-material";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { buttonClass } from "../../utils/Buttons";
import useOutsideClick from "../../Hooks/useOutsideClick";
import ProfileCard from "../../ProfileCard";

const CustomSelectField = withStyles({
  root: {
    marginTop: 8,
    backgroundColor: "#ffffff",
    borderRadius: 8,
    "& .MuiOutlinedInput-input": {
      padding: "12px 16px",
      fontSize: 14,
      fontWeight: 500,
      color: "#25265e",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "green",
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
      "& fieldset": {
        borderColor: "#DEE7EE",
      },
      "&:hover fieldset": {
        borderColor: "#DEE7EE",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#3D71FF",
      },
    },
  },
})(TextField);

const FieldLabel = ({ title }) => {
  return (
    <div className="t--sm t--subtitle t--500">
      {title.toUpperCase()} <span style={{ color: "#e91e63" }}>*</span>
    </div>
  );
};

const ModalUserEdit = ({ user, entity, organization_id, closeModal, setUsers, setNotice }) => {
  const [role, setRole] = useState(user.role);
  const [submitting, setSubmitting] = useState(false);

  const modalRef = useRef(null);
  useOutsideClick(modalRef, closeModal);

  const isDisabled = () => {
    return submitting;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);

    try {
      const response = await fetch(
        `/organization/${organization_id}/entities/${entity.id}/users/${user.id}`,
        {
          method: "PATCH",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-CSRF-Token": document
              .querySelector('meta[name="csrf-token"]')
              .getAttribute("content"),
          },
          body: JSON.stringify({ user: { role } }),
        }
      );

      const data = await response.json();

      if (!response.ok) throw new Error(data.error);

      setNotice({ kind: "success", open: true, message: data.notice });
      setUsers((prev) => prev.map((u) => (u.id === user.id ? data.user : u)));
      closeModal();
    } catch (error) {
      setNotice({ kind: "error", open: true, message: error.message || "An error occurred." });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="tpa-modal__background">
      <div className="tpa-modal__container" ref={modalRef}>
        <div className="tpa-modal__header">
          <div className="tpa-modal__header__img">
            <img src={backgroundImage} width={145} />
          </div>
          <div className="button button--sq-md button--transparent" onClick={closeModal}>
            <Close />
          </div>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="tpa-modal__body">
            <div className="flex flex-column gap--16">
              <div className="t--xl t--500">Edit Role</div>
              <div className="t--subtitle">
                Update the role for this team member on your covered entity account.
              </div>
              <ProfileCard
                initials={user.initials}
                title={user.name}
                subtitle={user.email}
                iconColor="light-blue"
              />
            </div>
            <div className="flex flex-column gap--16">
              <div className="t--16 t--500">Editing role for the following Covered Entity:</div>
              <ProfileCard
                initials={entity.entity_name[0]}
                title={entity.entity_name}
                subtitle={entity.id_340b}
              />
            </div>
            <div>
              <FieldLabel title="role" />
              <CustomSelectField
                select
                variant="outlined"
                id="role"
                fullWidth
                required
                SelectProps={{ native: true }}
                value={role}
                onChange={(e) => setRole(e.target.value)}
              >
                <option value="user">User</option>
                <option value="admin">Admin</option>
              </CustomSelectField>
            </div>
            <div className="flex justify-content-end gap--16">
              <button className="button button--white t--500" onClick={closeModal}>
                Cancel
              </button>
              <button type="submit" className={buttonClass(isDisabled())} disabled={isDisabled()}>
                Save
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ModalUserEdit;
